import { Injectable } from '@angular/core';
import { ClientService } from './client.service';
import { MeterRecordDataModel } from '../models/meter-record-data-model';
import { ModelFactory } from '../models/model-factory';
import { MeterControlModel } from '../models/meter-control-model';
import { MeterPreviewModel } from '../models/meter-preview-model';

@Injectable({
  providedIn: 'root',
})
export class MeterService {
  constructor(private client: ClientService) {}

  async getGlobalControls(): Promise<Array<MeterControlModel>> {
    return ModelFactory.newInstances(MeterControlModel, await this.client.get(`api/global/meters`));
  }

  async getGlobalControl(meterId: string): Promise<MeterControlModel> {
    return ModelFactory.newInstance(MeterControlModel, await this.client.get(`api/global/meters/${meterId}`));
  }

  async getAllControls(): Promise<Array<MeterControlModel>> {
    return ModelFactory.newInstances(MeterControlModel, await this.client.get(`api/meters`));
  }

  async getAllControlsPreview(valueType: string, startDate: string, endDate: string): Promise<Array<MeterPreviewModel>> {
    return ModelFactory.newInstances(
      MeterPreviewModel,
      await this.client.get(`api/meters/preview`, {
        valueType,
        startDate,
        endDate,
      })
    );
  }

  async getGlobalControlRecordData(meterId: string, valueType: string, startDate: string, endDate: string): Promise<MeterRecordDataModel> {
    return ModelFactory.newInstance(
      MeterRecordDataModel,
      await this.client.get(`api/global/meters/${meterId}/records`, {
        valueType,
        startDate,
        endDate,
      })
    );
  }

  async getControls(zoneId: string): Promise<Array<MeterControlModel>> {
    return ModelFactory.newInstances(MeterControlModel, await this.client.get(`api/zones/${zoneId}/meters`));
  }

  async getControl(zoneId: string, meterId: string): Promise<MeterControlModel> {
    return ModelFactory.newInstance(MeterControlModel, await this.client.get(`api/zones/${zoneId}/meters/${meterId}`));
  }

  async getControlRecordData(zoneId: string, meterId: string, valueType: string, startDate: string, endDate: string): Promise<MeterRecordDataModel> {
    return ModelFactory.newInstance(
      MeterRecordDataModel,
      await this.client.get(`api/zones/${zoneId}/meters/${meterId}/records`, {
        valueType,
        startDate,
        endDate,
      })
    );
  }

  async downloadControlRecordData(zoneId: string, meterId: string, valueType: string, startDate: string, endDate: string): Promise<void> {
    const data = await this.client.downloadFile(`api/zones/${zoneId}/meters/${meterId}/records/export`, {
      valueType,
      startDate,
      endDate,
    });

    const blob = new Blob([data], { type: 'text/xml' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');

    link.href = url;
    link.download = 'records.xml';
    link.click();

    window.URL.revokeObjectURL(url);
  }

  async downloadAllControlsPreview(valueType: string, startDate: string, endDate: string): Promise<void> {
    const data = await this.client.downloadFile(`api/meters/preview/export`, {
      valueType,
      startDate,
      endDate,
    });

    const blob = new Blob([data], { type: 'text/xml' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');

    link.href = url;
    link.download = 'preview.xml';
    link.click();

    window.URL.revokeObjectURL(url);
  }
}
